/** @file Bounds check for an index or code read from rig JSON; throws VALIDATION with the JSON path. */
import { coreFail } from '../coreFail';

/** Returns value when it is an integer in [0, length); otherwise throws VALIDATION at path. */
export function indexIn(value: number, length: number, path: string): number {
  if (Number.isInteger(value) && value >= 0 && value < length) return value;
  return coreFail('VALIDATION', `index ${String(value)} is out of range (${String(length)} available)`, { path });
}
